<template>
  <div>
    <NavBar />
    <div class="container-fluid">
      <v-card>
        <v-card-title> Permissões do cliente </v-card-title>
        <v-card-text>
          <v-expansion-panels accordion flat hover>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <h5 class="m-0">Grupos</h5>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <groups />
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <h5 class="m-0">Permissões</h5>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <permissions />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import { adminData } from "../lib/functions";
import Groups from "../templates/RestHomePermissions/Groups.vue";
import Permissions from "../templates/RestHomePermissions/Permissions.vue";

export default {
  name: "RestHomePermissions",
  components: {
    NavBar,
    Groups,
    Permissions,
  },
  data() {
    return {
      permissions: {},
    };
  },
  created() {
    this.permissions = adminData().permissions;
  },
};
</script>